export const REFUND_STATUSES: any = {
  RETURN: 'REGL. RETOURNE',
  VISITE: 'CONTRE VISITE',
  AGREEMENT: 'A C C O R D',
  REJECTED: 'DOSSIER REJETE',
  PAIED: 'REGLE',
  PEC_CANCELED: 'P.E.C ANNULEE',
  PENDING: 'EN COURS',
  COMPLEMENTARY_INFO: 'COMPLEMENT INFO',
  PEC: 'PRISE EN CHARGE',
  S_SUITE: 'CLOTURE S.SUITE',
  CI_ENCOURS: 'CI EN TRAITEMENT',
};

export const REQUESTS_STATUSES: any = {
  CREATED: 0,
  VALIDATED: 2,
  REJECTED: 3,
};
